import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getfoliotransactionledger, gettransactiondetailsbyaudit, getInvoiceDetailsById, getBillDetailsById, paydisburesment, cancellastdisbursement, cancelreceipt, getviewreceiptdetails, generatereceiptreport, transferdeposit, generatedisbursementstatementreport, generatetenantledgerreport, viewtenantfoliodetails, updaterentvariation, cancelBills, cancelInvoice } from "../../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../../Utilities/client";
import { useSpinnerContext } from "../../../../Utilities/SpinnerContext";
import "../../../../components/Dashboard/Dashboard-agent/AgentList.css";
import { ActionStatus } from "../../../../Utilities/enum";
import { addParametersForProfiles, dynamicUrl } from "../../../../Utilities/profileManagement";
import SubNav from "../../../navbar/subNav";
import AntdTableExample from "../../../input-components/dataTable";
import { Button, message, Table, Dropdown, Tabs, Input, DatePicker, Checkbox } from "antd";
import moment from "moment";
import CustomModal from "../../../input-components/Modal";
import ShowValue from "../../../input-components/ShowValue";
import { format } from 'date-fns';
import "./folio.css";
import ToastAlert from "../../../../components/CommonSection/ToastAlert/ToastAlert";
import TextArea from "../../../input-components/textarea";
import locale from "antd/es/date-picker/locale/en_GB";
import { formatAmount } from "../../../../components/CommonSection/Utility/Utility";

const Folio = () => {
  const navigate = useNavigate();
  const { showSpinner, hideSpinner } = useSpinnerContext();
  const [ownerFolioLists, setOwnerFolioLists] = useState([]);
  const [allDetails, setAllDetails] = useState({});
  const [purpose, setPurpose] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rows, setRows] = useState(10);
  const [viewTransactionDetails, setViewTransactionDetails] = useState(false)
  const [getDetails, setGetDetails] = useState(null);
  const [openDisburseModle, setOpenDisburseModle] = useState(false)
  const [reverseReason, setReverseReason] = useState("");
  const [viewReverseReason, setViewReverseReason] = useState(false);
  const [transferRows, setTransferRows] = useState([]);
  const [showTransferDeposit, setShowTransferDeposit] = useState(false);
  const [receiptDetails, setReceiptDetails] = useState({});
  const [openRentReview, setOpenRentReview] = useState(false)
  const [rentReviewDetails, setRentReviewDetails] = useState({});
  const [folioUid, setFolioUid] = useState('');
  const [userId, setUserId] = useState("");
  const [agencyID, setAgencyId] = useState("");
  const [rentAdjustment, setRentAdjustment] = useState({
    noticePeriod: "",
    newRentFrom: null,
    newRentValue: "",
  });
  const urlParams = new URLSearchParams(window.location.search);
  const folio = urlParams.get("folio");
  const ToastRef = useRef();

  const { TabPane } = Tabs;

  useEffect(() => {
    const retrieveData = async () => {
      try {
        const userData = GetCookie("@UserData");
        if (userData) {
          const parsedData = JSON.parse(userData);
          setUserId(parsedData.userId);
          setAgencyId(parsedData.agencyID);
          getSupportList(folio, currentPage, parsedData.agencyID, purpose);
        }
      } catch (error) {
        console.error("Error retrieving data from AsyncStorage:", error);
      }
    };
    retrieveData();
  }, []);

  const getContactTypeFromFolio = (folio) => {
    const preText = folio.trim().substring(0, 3).toUpperCase();

    switch (preText) {
      case "TEN":
        return "Tenant";
      case "OWN":
        return "Owner";
      case "SUP":
        return "Supplier";
      default:
        return "Other";
    }
  };
  const folioType = getContactTypeFromFolio(folio);


  const getSupportList = (folio, currentPage, agencyID, purpose) => {
    const baseUrl = getfoliotransactionledger;
    const requestData = addParametersForProfiles({
      AgencyId: agencyID,
      Folio: folio,
      TabId: purpose,
      PageNo: currentPage,
    });

    makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", requestData)
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          setAllDetails(response.object);
          setTotalPages(response.totalCount)
          let dataList = [];
          debugger
          if (purpose === 3 && folioType === "Owner" || purpose === 4 && folioType === "Owner" || folioType === "Supplier" && purpose === 3 || folioType === "Supplier" && purpose === 4) {
            dataList = response.object.bills?.map((item) => ({
              bill: item.id,
              supplier: item.supplierName,
              property: item.propertyAddress,
              ref: item.reference,
              due: moment(item.dueDate).format("DD/MM/YYYY"),
              account: item.accountChart,
              detail: item.details,
              tax: item.isTax ? "Yes" : "No",
              amount: formatAmount(item.amount),
              uid: item.uid,
              attachment: item.isAttached,
              attachmentPath: item.attachment
            })) || [];
          }
          else if (folioType === "Tenant" && purpose === 3 || folioType === "Tenant" && purpose === 4 || purpose === 5 && folioType === "Owner" || purpose === 5 && folioType === "Supplier") {
            dataList = response.object.invoices?.map((item) => ({
              invoices: item.id,
              due: moment(item.date).format("DD/MM/YYYY"),
              account: item.accountChart,
              details: item.details,
              Tax: item.isTax ? "Yes" : "No",
              amount: formatAmount(item.amount),
              paidAmount: formatAmount(item.paidAmount),
              uid: item.uid
            })) || [];
          }
          else if (folioType === "Owner" && purpose === 6 || folioType === "Tenant" && purpose === 6 || folioType === "Supplier" && purpose === 6) {
            dataList = response.object.statements?.map((item) => ({
              Amount: formatAmount(item.amount),
              CreatedAt: moment(item.createdAt).format("DD/MM/YYYY"),
              StatementId: item.statementId,
              paidby: item.paidBy,
              disbursementId: item.disbursementId,
            })) || [];
          }
          else if (folioType === "Tenant" && purpose === 7) {
            dataList = response.object.receipts?.map((item) => ({
              ReceiptNo: item.receiptId,
              PaymentMethod: item.sPaymentMethod,
              Amount: formatAmount(item.amount),
              CreatedAt: moment(item.createdAt).format("DD/MM/YYYY"),
              paidby: item.paidBy,
            })) || [];
          }
          else {
            dataList = response.object.ledgerTransaction?.map((item) => ({
              auditNumer: item.auditNumer,
              createdAt: moment(item.createdAt).format("DD/MM/YYYY"),
              reference: item.reference,
              Type: item.sType,
              propertyAddress: item.propertyAddress,
              summary: item.summary,
              debit: item.debit ? `${formatAmount(item.debit)}` : "",
              credit: item.credit ? `${formatAmount(item.credit)}` : "",
            })) || [];
          }
          setOwnerFolioLists(dataList);
        } else {
          message.error(response.message);
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  const handlePageChange = (pageNumber, totalRows) => {
    setCurrentPage(pageNumber);
    setRows(totalRows);
    getSupportList(folio, pageNumber, agencyID, purpose);
  };


  const renderFinancialButtons = (type) => {
    const isNumber = (val) =>
      typeof val === "number" || (!isNaN(val) && val !== "");

    const formatAmount = (val) => {
      const num = parseFloat(val);
      return isNaN(num) ? val : `$${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    const financialData = type === "Owner"
      ? [
        { label: "Opening", value: allDetails?.openingBal },
        { label: "Money In", value: allDetails?.moneyIn },
        { label: "Money Out", value: allDetails?.moneyOut },
        { label: "Withhold", value: allDetails?.without },
        { label: "Uncleared", value: allDetails?.uncleared },
        { label: "Bill Pending", value: allDetails?.billsPending },
        { label: "Balance", value: allDetails?.calculatedBalance },
      ]
      : type === "Supplier"
        ? [
          { label: "Opening Balance", value: allDetails?.openingBal },
          { label: "Money In", value: allDetails?.moneyIn },
          { label: "Money Out", value: allDetails?.moneyOut },
          { label: "Pending", value: allDetails?.billsPending },
          { label: "Balance", value: allDetails?.calculatedBalance },
        ]
        : [
          { label: "Paid To", value: allDetails?.tenantFolioDetails?.paidTo ? moment(allDetails?.tenantFolioDetails?.paidTo).format("DD/MM/YYYY") : "" },
          { label: "Part Paid", value: allDetails?.tenantFolioDetails?.partPaid },
          { label: "Deposits", value: allDetails?.tenantFolioDetails?.deposit },
          { label: "Uncleared", value: allDetails?.uncleared },
          { label: "Bond Held", value: allDetails?.tenantFolioDetails?.bondHeld },
          allDetails?.tenantFolioDetails?.nextRentDate ? { label: "Next Rent From", value: allDetails?.tenantFolioDetails?.nextRentDate ? moment(allDetails?.tenantFolioDetails?.nextRentDate).format("DD/MM/YYYY") : "" } : null,
          allDetails?.tenantFolioDetails?.nextRent ? { label: "Next Rent", value: allDetails?.tenantFolioDetails?.nextRent } : null,
          allDetails?.tenantFolioDetails?.effectivePaidDate ? { label: "Eff Paid Date", value: allDetails?.tenantFolioDetails?.effectivePaidDate ? moment(allDetails?.tenantFolioDetails?.effectivePaidDate).format("DD/MM/YYYY") : "" } : null,
          allDetails?.tenantFolioDetails?.isRentPaidToVacate ? { label: "", value: "Paid to vacate" } : null,
        ].filter(Boolean); // Removes null entries

    return (
      <div className="financial-summary-cards">
        {financialData.map((btn, index) => (
          <div className="summary-card" key={index}>
            <div className="summary-label">{btn.label}</div>
            <div className="summary-value">
              {btn.value !== undefined && btn.value !== null && btn.value !== ""
                ? isNumber(btn.value)
                  ? formatAmount(btn.value)
                  : btn.value
                : ""}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const handleTab = (id) => {
    debugger
    setPurpose(id),
    getSupportList(folio, currentPage, agencyID, id);
    
  }

  const renderNavigation = (options) => (
    <div>
      {options.map((opt) => (
        <span
          key={opt.id}
          className={`stat-items ${purpose === opt.id ? "active" : ""}`}
          onClick={() => handleTab(opt.id)}
        >
          {opt.label}
        </span>
      ))}
    </div>
  );

  const ownerNavOptions = [
    { id: 1, label: "Current Transactions" },
    { id: 2, label: "All Transactions" },
    { id: 3, label: "Pending Bills" },
    { id: 4, label: "Paid Bills" },
    { id: 5, label: "Pending Invoice" },
    { id: 6, label: "Statements" }
  ];



  const otherNavOptions = [
    { id: 1, label: "Current Month" },
    { id: 2, label: "All Transactions" },
    { id: 3, label: "Pending Invoices" },
    { id: 4, label: "Paid Invoice" },
    { id: 5, label: "Rent Actions" },
    { id: 6, label: "Statements" },
    { id: 7, label: "Receipts" }
  ];

  const actions = [
    { icon: "/assets/images/download.png", key: "download", onClick: (e, data) => handlePrint(e, data) },
  ]

  const actionsDelete = [
    { icon: "/assets/images/trash.png", key: "download", onClick: (e, data) => deletBill(e, data) },
  ]

  const GetDetailsApiTransaction = (data) => {
    const url = gettransactiondetailsbyaudit + `?AuditId=${data}`;
    makeRequestWithSpinner(showSpinner, hideSpinner, url, "get", "", null, false)
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          setGetDetails(response.object);
        }
      })
      .catch((error) => {
        console.error("Error fetching ticket details:", error);
      })
      .finally(() => {
        //setLoading(false); // Set loading to false once API call completes
      });
  };

  const viewTransactionDetail = (e, data) => {
    setGetDetails(null)
    if (
      (folioType === "Tenant" || folioType === "Owner") && (purpose === 1 || purpose === 2)
    ) {
      GetDetailsApiTransaction(data.auditNumer);
      setViewTransactionDetails(true);

    } else if (
      folioType === "Tenant" && (purpose === 3 || purpose === 4)
    ) {
      GetDetailsApiInvoice(data.uid);
      setViewTransactionDetails(true);

    } else if (
      folioType === "Owner" && (purpose === 3 || purpose === 4)
    ) {
      GetDetailsApiBills(data.uid);
      setViewTransactionDetails(true);

    }
  };


  const closeViewTrasaction = () => {
    setViewTransactionDetails(false)
  }

  const columns = [
    {
      title: "Contact",
      dataIndex: "contactName",
      key: "contactName",
      render: (text) => <span style={{ color: "#1890ff", cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Folio",
      dataIndex: "folio",
      key: "folio",
      render: (text) => <span style={{ color: "#1890ff", cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Chart Account",
      dataIndex: "accountChart",
      key: "accountChart",
    },
    {
      title: "Detail",
      dataIndex: "details",
      key: "details",
    },
    {
      title: "Tax",
      dataIndex: "tax",
      key: "tax",
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => `${formatAmount(amount)}`,
    },
  ];

  const columnsInv = [
    {
      title: "Contact",
      dataIndex: "tenantName",
      key: "tenantName",
      render: (text) => <span style={{ color: "#1890ff", cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Folio",
      dataIndex: "folio",
      key: "folio",
      render: (text) => <span style={{ color: "#1890ff", cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Chart Account",
      dataIndex: "accountName",
      key: "accountName",
    },
    {
      title: "Detail",
      dataIndex: "details",
      key: "details",
    },
    {
      title: "Tax",
      dataIndex: "isTax",
      key: "isTax",
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => `${formatAmount(amount)}`,
    },
  ];

  const GetDetailsApiInvoice = (invoiceId) => {
    const url = getInvoiceDetailsById + `?InvoiceId=${invoiceId}`;
    makeRequestWithSpinner(showSpinner, hideSpinner, url, "get", "", null, false)
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          setGetDetails(response.object);
        }
      })
      .catch((error) => {
        console.error("Error fetching ticket details:", error);
      })
      .finally(() => {
        //setLoading(false); // Set loading to false once API call completes
      });
  };

  const GetDetailsApiBills = (BillId) => {
    const url = getBillDetailsById + `?BillId=${BillId}`;
    makeRequestWithSpinner(showSpinner, hideSpinner, url, "get", "", null, false)
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          setGetDetails(response.object);
        }
      })
      .catch((error) => {
        console.error("Error fetching ticket details:", error);
      })
      .finally(() => {
        //setLoading(false); // Set loading to false once API call completes
      });
  };

  const invoiceData = getDetails
    ? [
      {
        key: getDetails?.id,
        tenantName: getDetails?.tenantName || "N/A",
        folio: getDetails?.folio || "N/A",
        accountName: getDetails?.accountName || "N/A",
        details: getDetails?.details || "N/A",
        isTax: getDetails?.isTax,
        amount: getDetails?.amount || 0,
      },
    ]
    : [];

  const billData = getDetails
    ? [
      {
        key: getDetails?.id,
        ownerName: getDetails?.ownerName || "N/A",
        folio: getDetails?.ownerFolio || "N/A",
        accountName: getDetails?.accountChart || "N/A",
        details: getDetails?.details || "N/A",
        isTax: getDetails?.isTax,
        amount: getDetails?.amount || 0,
      },
    ]
    : [];


  const title =
    ((purpose === 1 || purpose === 2))
      ? `${getDetails?.transactionType} #${getDetails?.referenceId} - ${getDetails?.paymentDescription}`
      : (folioType === "Tenant" && (purpose === 3 || purpose === 4))
        ? `Invoice #${getDetails?.id} - ${getDetails?.details}`
        : (folioType === "Owner" && (purpose === 3 || purpose === 4)) ? `Bill #${getDetails?.id} - ${getDetails?.details}` : "";

  const handleProperty = (data) => {
    navigate(`/agency/viewPropertyDetails?propertyUID=${data}`);
  }

  const closeDisburse = () => {
    setOpenDisburseModle(false)
  }

  const submitDisburse = () => {
    const baseUrl = paydisburesment;
    let data = {
      AgencyId: agencyID,
      Folios: [folio]
    };

    data = addParametersForProfiles(data);
    makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          getSupportList(folio, pageNumber, agencyID, purpose);
          ToastRef.current.notify(["success", response.message]);
          setOpenDisburseModle(false);
        } else {
          ToastRef.current.notify(["error", response.message]);
        }
      })
  };

  const submitDisburseCancel = () => {
    const baseUrl = cancellastdisbursement;
    let data = {
      AgencyId: agencyID,
      FolioCode: folio
    };

    data = addParametersForProfiles(data);
    makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          ToastRef.current.notify(["success", response.message]);
          getSupportList(folio, currentPage, agencyID, purpose);
        } else {
          ToastRef.current.notify(["error", response.message]);
        }
      })
  }


  const handleEdit = (e) => {
    if (e === 2) {
      dynamicUrl(navigate, `viewPropertyDetails?propertyUID=${allDetails?.propertyUId}&&step=${e}&&subTab=folio`);
    } else if (e === "tenant") {
      dynamicUrl(navigate, `viewPropertyDetails?propertyUID=${allDetails?.propertyUId}&&step=${e}`);
    } else {
      navigate("/contactlist" + `?contactUID=${allDetails?.contactUId}&&step=${e}`);
    }
  }

  const openTransferDeposit = () => {
    setShowTransferDeposit(true);
    viewreceiptdetails(allDetails?.propertyId)
  };

  const closeTransferDeposit = () => {
    setShowTransferDeposit(false);
  };


  const handleActionReport = () => {
    const baseUrl = `${generatetenantledgerreport}?TenantFolioCode=${folio}`;
    showSpinner();
    fetch(baseUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        if (!res.ok) throw new Error("Failed to generate tenant ledger report");

        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);

        // Open in new tab
        window.open(url, "_blank");

      })
      .catch((err) => {
        ToastRef.current.notify(["error", err.message || "Something went wrong"]);
      })
      .finally(() => {
        hideSpinner();
      });
  };

  const handleRentReview = (id) => {
    setOpenRentReview(true);
    const baseUrl = viewtenantfoliodetails + `?TenantFolio=${id}`;
    makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "get")
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          const details = response.object?.tenantFolioDetails || {};
          setRentReviewDetails(response.object);
          const hasNextRent = details.nextRent !== null && details.nextRent !== undefined;
          const hasNextRentDate = details.nextRentDate !== null && details.nextRentDate !== undefined;
          const newRentFrom = hasNextRentDate ? moment(details.nextRentDate) : moment();
          const today = moment().startOf("day");
          const noticePeriod = newRentFrom.diff(today, "days");

          setRentAdjustment({
            newRentFrom,
            noticePeriod,
            newRentValue: hasNextRent ? details.nextRent : details.rent,
          });

        }
      });
  };

  const actionOwner = [
    { key: '1', label: (<a onClick={() => handleEdit(2)}>Edit</a>) },
    { key: '2', label: (<span style={{ color: allDetails?.calculatedBalance <= 0 ? "#ccc" : "inherit" }} onClick={submitDisburse}>Disburse</span>), disabled: allDetails?.calculatedBalance <= 0 },
    { key: '3', label: (<a onClick={submitDisburseCancel}>Reverse Last Disbursement</a>) },
    { key: '4', label: (<a onClick={(e) => deletBill(e, folioUid, null)}>Delete</a>) },
  ];

  const reportOwner = [
    { key: '1', label: (<a >Summary</a>) },
    { key: '2', label: (<a >Ledger</a>) },
    { key: '3', label: (<a >Statements</a>) },
  ];

  const actionTenant = [
    { key: '1', label: (<a onClick={() => handleEdit("tenant")}>Edit</a>) },
    { key: '2', label: (<span style={{ color: allDetails?.calculatedBalance <= 0 ? "#ccc" : "inherit" }} onClick={submitDisburse}>Disburse</span>), disabled: allDetails?.calculatedBalance <= 0 },
    { key: '3', label: (<a onClick={openTransferDeposit}>Transfer Deposit</a>) },
    { key: '4', label: (<a onClick={() => handleRentReview(folio)}>Adjust Rent</a>) },
    { key: '5', label: (<a >Add Credit</a>) },
    { key: '6', label: (<a >Rent Management</a>) },
    { key: '4', label: (<a onClick={(e) => deletBill(e, folioUid, null)}>Delete</a>) },
  ];


  const actionSupplier = [
    { key: '1', label: (<a onClick={() => handleEdit("supplier")}>Edit</a>) },
    { key: '2', label: (<span style={{ color: allDetails?.calculatedBalance <= 0 ? "#ccc" : "inherit" }} onClick={submitDisburse}>Disburse</span>), disabled: allDetails?.calculatedBalance <= 0 },
    { key: '3', label: (<a onClick={submitDisburseCancel}>Reverse Last Disbursement</a>) },
  ];


  const reportSupplier = [
    { key: '1', label: (<a >Summary</a>) },
    { key: '2', label: (<a >Ledger</a>) },
    { key: '3', label: (<a >Statements</a>) },
  ];

  const actionReport = [
    { key: '1', label: (<a onClick={handleActionReport}>Tenant History</a>) },
  ]


  const handleReverse = (id) => {
    const payload = {
      ReceiptId: id,
      ReverseReason: reverseReason
    };

    makeRequestWithSpinner(showSpinner, hideSpinner, cancelreceipt, "post", payload)
      .then((res) => {
        if (res.status === 1) {
          ToastRef.current.notify(["success", res.message]);
        } else {
          ToastRef.current.notify(["error", res.message]);
        }
      })
      .catch(() => {
        ToastRef.current.notify(["error", "Something went wrong."]);
      });
  }

  const closeReverseReason = () => {
    setViewReverseReason(false)
  }

  const handleReverseReason = () => {
    setViewReverseReason(true)
  }

  const calculateDifference = () => {
    const deposit = parseFloat(receiptDetails?.depositAmount || 0);
    const allocated = transferRows
      .filter(row => row.allocation !== "Deposit")
      .reduce((sum, row) => sum + parseFloat(row.amount || 0), 0);

    return deposit - allocated;
  };



  const viewreceiptdetails = (propertyId) => {
    const baseUrl = getviewreceiptdetails;
    const apiUrl = `${baseUrl}?PropertyId=${propertyId}`;

    makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "get")
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          const details = response.object;
          setReceiptDetails(details);

          const rows = [];

          // Add Rent Row
          rows.push({
            allocation: "Rent",
            due: moment(details.rentDue).format("DD MMM YYYY"),
            description: `${details.description} + ${formatAmount(details.totalAmountRentDue)}`,
            amountDue: `${details.amountDueDays} days`,
            amount: "", // user will input this
          });


          // Add Invoice Rows
          const invoiceRows = (details.invoiceDueList || []).map(inv => ({
            allocation: "Invoice",
            due: moment(inv.dueDate).format("DD MMM YYYY"),
            description: inv.description,
            amountDue: `${formatAmount(inv.amountDue) || "0.00"}`,
            amount: "",
            invoiceId: inv.id  // ✅ Add this for backend reference
          }));


          rows.push(...invoiceRows);

          // Add Deposit Row (pre-filled)
          rows.push({
            allocation: "Deposit",
            due: "",
            description: "Remaining deposit",
            amountDue: "",
            amount: details.depositAmount ? formatAmount(details.depositAmount) : 0,
            isDepositRow: true,
          });

          setTransferRows(rows);
        } else {
          ToastRef.current?.notify(["error", response.message]);
        }
      })
      .catch(() => {
        ToastRef.current?.notify(["error", "Failed to load receipt details."]);
      });
  };

  const submitTransfer = () => {
    const invoicePayments = [];
    let rentAmount = 0;

    transferRows.forEach(row => {
      const amount = parseFloat(row.amount || 0);

      if (row.allocation === "Rent") {
        rentAmount += amount;
      } else if (row.allocation === "Invoice" && amount > 0) {
        invoicePayments.push({
          InvoiceId: row.invoiceId, // ✅ pulled from mapped rows
          Amount: amount,
        });
      }
    });

    const payload = {
      id: 0,
      Date: new Date().toISOString(),
      Description: "Transfer from deposit",
      RentAmount: rentAmount,
      PropertyId: allDetails?.propertyId,
      AgencyId: agencyID,
      UserId: userId,
      InvoicePayments: invoicePayments
    };

    makeRequestWithSpinner(showSpinner, hideSpinner, transferdeposit, "post", payload)
      .then((res) => {
        if (res.status === ActionStatus.Successfull) {
          ToastRef.current.notify(["success", res.message]);
          closeTransferDeposit();
        } else {
          ToastRef.current.notify(["error", res.message]);
        }
      })
      .catch(() => {
        ToastRef.current.notify(["error", "Something went wrong."]);
      });
  };

  const handlePrint = (e, details) => {
    e.stopPropagation()
    e.preventDefault()
    const baseUrl = purpose === 6 ? generatedisbursementstatementreport : generatereceiptreport;
    const data = {
      AgencyId: agencyID,
      ...(purpose === 6
        ? { DibsursmentId: details.disbursementId }
        : { ReceiptId: details.ReceiptNo }),
    };

    showSpinner();

    fetch(baseUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(async (res) => {
        if (!res.ok) throw new Error("Failed to generate disbursement PDF");

        const disposition = res.headers.get("Content-Disposition");
        let fileName = purpose === 6 ? `statement_${details.paidby}.pdf` : `receipt_${details.paidby}.pdf`;

        if (disposition) {
          const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/);
          const fallbackMatch = disposition.match(/filename="?([^"]+)"?/);
          if (utf8Match?.[1]) {
            fileName = decodeURIComponent(utf8Match[1]);
          } else if (fallbackMatch?.[1]) {
            fileName = fallbackMatch[1];
          }
        }

        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        ToastRef.current.notify(["success", "Disbursement downloaded successfully."]);
      })
      .catch((err) => {
        ToastRef.current.notify(["error", err.message || "Something went wrong"]);
      })
      .finally(() => {
        hideSpinner();
      });
  };

  const closeRentReview = () => {
    setOpenRentReview(false)
  }

  const handleRentChange = (field, value) => {
    const updated = { ...rentAdjustment };

    if (field === "newRentFrom") {
      if (!value) {
        updated.newRentFrom = null;
        updated.noticePeriod = "";
      } else {
        const selectedDate = value.clone().startOf("day");
        const today = moment().startOf("day");
        updated.newRentFrom = selectedDate;
        updated.noticePeriod = selectedDate.diff(today, "days");
      }
    } else if (field === "noticePeriod") {
      const period = parseInt(value, 10);
      updated.noticePeriod = isNaN(period) ? "" : period;
      // 👇 Only update date if it was originally derived
      if (!rentAdjustment.newRentFrom || rentAdjustment.newRentFrom.isSame(moment().startOf("day"))) {
        updated.newRentFrom = moment().startOf("day").add(period, "days");
      }
    } else {
      updated[field] = value;
    }

    setRentAdjustment(updated);
  };

  const SubmitRentReview = () => {
    const baseUrl = updaterentvariation;
    let finalData = {
      TenantFolio: folio,
      NextRentDate: rentAdjustment.newRentFrom.format("MM-DD-YYYY"),
      NextRent: rentAdjustment.newRentValue,
      NextRentNoticePeriod: rentAdjustment.noticePeriod
    }
    makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", finalData)
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          getSupportList(folio, currentPage, agencyID, purpose);
          setOpenRentReview(false);
          ToastRef.current.notify(["success", response.message]);
        }
      })
  }

  const deletBill = async (e, data, multi) => {
    e.stopPropagation();
    e.preventDefault();
    let uid = multi === null ? data : data.uid
    makeRequestWithSpinner(
      showSpinner,
      hideSpinner,
      `${folioType === "Owner" ? cancelBills : cancelInvoice}?uids=${uid}`,
      "delete"
    )
      .then((returnData) => {
        if (returnData.status == ActionStatus.Successfull) {
          getSupportList(folio, currentPage, agencyID, purpose);
          ToastRef.current.notify(["success", returnData.message]);
          setOpenAddProperty(false);
        } else {
          ToastRef.current.notify(["error", returnData.message]);
        }
      })
      .catch((error) => {
        ToastRef.current.notify(["error", error]);
      });
  };

  const onSelectedRowKeysChange = (data, id) => {
    const selectedIds = id.map(row => row.uid).join(',');
    setFolioUid(selectedIds);
  }

  let showAction = (purpose === 6) && (folioType === "Owner" || folioType === "Tenant" || folioType === "Supplier") || (folioType === "Tenant" && purpose === 7);
  const tenant = rentReviewDetails?.tenantFolioDetails;


  return (
    <div className="px-0 changedateantdstyle">
      <SubNav title={`${folioType} Folio - ${folioType !== "Owner" ? allDetails.folioReferencce : ""} (${folio})`} goback={true} extraData={true} extraContent={
        <div className="property-details-buttons">
          {folioType === "Tenant" && (
            <Dropdown menu={{ items: actionReport }} placement="bottom">
              <Button className="withdraw-btn ">Reports</Button>
            </Dropdown>)}
          <Dropdown menu={{ items: folioType === "Owner" ? actionOwner : folioType === "Supplier" ? actionSupplier : actionTenant }} placement="bottom">
            <Button className="withdraw-btn mr-2">Actions</Button>
          </Dropdown>
          {(folioType === "Owner" || folioType === "Supplier") && (
            <Dropdown menu={{ items: folioType === "Owner" ? reportOwner : reportSupplier }} placement="bottom" className="mr-2">
              <Button className="mr-2 withdraw-btn">Reports</Button>
            </Dropdown>
          )}
        </div>
      } />
      <div className="material-work-desk-new bg-white m-3">
        <ToastAlert ref={ToastRef} />
        {folioType === "Owner" || folioType === "Supplier" ? renderNavigation(ownerNavOptions) : renderNavigation(otherNavOptions)}
        {renderFinancialButtons(folioType)}

        <AntdTableExample
          showCheckbox={(purpose === 3 && (folioType === "Owner" || folioType === "Tenant"))}
          label={`List ${folioType} Folio`}
          dataSource={ownerFolioLists}
          globalSearch
          hideCol={"id,uid,disbursementId"}
          onPageChange={handlePageChange}
          currentPage={currentPage}
          totalRows={rows}
          totalRecords={totalPages}
          actions={showAction ? actions : (purpose === 3 && (folioType === "Owner" || folioType === "Tenant")) ? actionsDelete : null}
          onRowClick={viewTransactionDetail}
          onSelectedRowKeysChange={onSelectedRowKeysChange}
        />
      </div>

      <CustomModal footer={null} title={title} width={1000} closable={closeViewTrasaction} visible={viewTransactionDetails} onCancel={closeViewTrasaction}
        modalData={
          <div>
            {getDetails?.transactionType === "Receipt" ?
              <div className="ml-3" style={{ float: 'right' }}>
                <Button className="withdraw-btn" type="default" onClick={() => handleReverseReason()}>
                  Reverse
                </Button>
              </div> : null}
            {((purpose === 1) || (purpose === 2)) ?
              <div className="details-form p-3">
                <div className="contacts-group">
                  <ShowValue Label='Created Date' setData={getDetails?.createdAt ? format(new Date(getDetails.createdAt), 'dd/MM/yyyy hh:mm') : "N/A"} />
                  <ShowValue Label='Paid By' setData={getDetails?.paidBy} />
                  <ShowValue Label='Transaction Date' setData={getDetails?.transactionDate ? format(new Date(getDetails.transactionDate), 'dd/MM/yyyy hh:mm') : "N/A"} />
                  <ShowValue Label='Property' setData={getDetails?.propertyAddress ? getDetails?.propertyAddress : "N/A"} onClick={() => handleProperty(getDetails?.propertyUId)} link={true} />
                  <ShowValue Label='Processed By' setData={getDetails?.processedBy} />

                  <h6 style={{ marginTop: "20px" }}>Transaction Details</h6>
                  <Table columns={columns} dataSource={getDetails?.transactionsDetails} pagination={false} />

                  <div style={{ textAlign: "right", marginTop: "10px", fontSize: "16px", fontWeight: "bold", marginRight: '20px' }}>
                    Total: {getDetails?.totalAmount ? formatAmount(getDetails.totalAmount) : "0.00"}
                  </div>
                </div>
              </div>
              :
              (folioType === "Tenant" && purpose === 3 || folioType === "Tenant" && purpose === 4) ?
                <div className="details-form p-3">
                  <div className="contacts-group">
                    <ShowValue Label='Created Date' setData={getDetails?.addedOn ? format(new Date(getDetails.addedOn), 'dd/MM/yyyy hh:mm') : "N/A"} />
                    <ShowValue Label='Issued By' setData={getDetails?.issueByFolio} onClick={() => handlefolio("Owner", getDetails?.issueByFolio)} link={true} />
                    <ShowValue Label='Due Date' setData={getDetails?.date ? format(new Date(getDetails.date), 'dd/MM/yyyy hh:mm') : "N/A"} />
                    <ShowValue Label='Property' setData={getDetails?.propertyName ? getDetails?.propertyName : "N/A"} onClick={() => handleProperty(getDetails?.propertyUId)} link={true} />
                    {getDetails?.attachment_Path && (
                      <div className={`row`}>
                        <div className={"label"}>
                          <div style={{ color: "#5E696E", fontWeight: '500' }}>{"Document"}:</div>
                        </div>
                        <div className={"value"} style={{ cursor: 'pointer' }} onClick={handleDownload}>
                          {extractFileName(getDetails.attachment_Path)}
                          <span className="ml-2 icon" title="Download"><FaDownload /></span>
                        </div>
                      </div>
                    )}
                    <h6 style={{ marginTop: "20px" }}>Invoice Details</h6>
                    <Table columns={columnsInv} dataSource={invoiceData} pagination={false} />

                    {/* Total Section */}
                    <div style={{ textAlign: "right", marginTop: "10px", fontSize: "16px", fontWeight: "bold" }}>
                      Total: {getDetails?.amount ? formatAmount(getDetails.amount) : "0.00"}
                    </div>
                  </div>
                </div>
                :
                <div className="details-form p-3">
                  <div className="contacts-group">
                    <ShowValue Label='Created Date' setData={getDetails?.addedOn ? format(new Date(getDetails.addedOn), 'dd/MM/yyyy hh:mm') : "N/A"} />
                    <ShowValue Label='reference' setData={getDetails?.reference ? getDetails?.reference : "N/A"} />
                    <ShowValue Label='supplier' setData={getDetails?.supplierName ? getDetails?.supplierName : "N/A"} />
                    <ShowValue Label='Due Date' setData={getDetails?.dueDate ? format(new Date(getDetails.dueDate), 'dd/MM/yyyy hh:mm') : "N/A"} />
                    <ShowValue Label='Property' setData={getDetails?.propertyAddress ? getDetails?.propertyAddress : "N/A"} onClick={() => handleProperty(getDetails?.propertyUId)} link={true} />
                    <ShowValue Label='Processed By' setData={getDetails?.processedBy ? getDetails?.processedBy : "N/A"} />
                    {getDetails?.attachment && (
                      <div className={`row`}>
                        <div className={"label"}>
                          <div style={{ color: "#5E696E", fontWeight: '500' }}>{"Document"}:</div>
                        </div>
                        <div className={"value"} style={{ cursor: 'pointer' }} onClick={handleDownload}>
                          {extractFileName(getDetails.attachment)}
                          <span className="ml-2 icon" title="Download"><FaDownload /></span>
                        </div>
                      </div>
                    )}
                    <h6 style={{ marginTop: "20px" }}>Bill Details</h6>
                    <Table columns={columns} dataSource={billData} pagination={false} />

                    {/* Total Section */}
                    <div style={{ textAlign: "right", marginTop: "10px", fontSize: "16px", fontWeight: "bold" }}>
                      Total: {getDetails?.amount ? formatAmount(getDetails.amount) : "0.00"}
                    </div>
                  </div>
                </div>}
          </div>
        }

      />

      <CustomModal
        footer={null}
        title="Transfer Deposit"
        width={1000}
        closable={closeTransferDeposit}
        visible={showTransferDeposit}
        onCancel={closeTransferDeposit}
        modalData={
          <div className="details-form p-3">
            <div className="contacts-group pl-2">
              <div className="d-flex justify-content-between">
                <div style={{ width: "50%" }}>
                  <ShowValue Label="Tenant" setData={receiptDetails?.tenantDetails || "N/A"} />
                  <ShowValue Label="Owner" setData={receiptDetails?.ownerDetails || "N/A"} />
                  <ShowValue Label="Property" setData={receiptDetails?.propertyAddress || "N/A"} />
                  <ShowValue Label="Details" setData={`${formatAmount(receiptDetails?.rent) || "0.00"} ${receiptDetails?.sRentTenure?.toLowerCase()}`} />
                </div>
                <div style={{ width: "20%" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                    <span style={{ fontWeight: 600 }}>
                      Deposit Balance: {formatAmount(receiptDetails?.depositAmount) || "0.00"}
                    </span>
                  </div>

                </div>
              </div>
              <div style={{ marginTop: 20 }}>
                <Table
                  pagination={false}
                  bordered
                  columns={[
                    {
                      title: "Allocation",
                      dataIndex: "allocation",
                      render: (text) => <b>{text}</b>,
                    },
                    { title: "Due", dataIndex: "due" },
                    { title: "Description", dataIndex: "description" },
                    { title: "Amount Due", dataIndex: "amountDue" },
                    {
                      title: "Amount",
                      dataIndex: "amount",
                      render: (_, record, idx) => (
                        <input
                          type="number"
                          value={record.amount}
                          onChange={(e) => {
                            const updatedRows = [...transferRows];
                            updatedRows[idx].amount = e.target.value;

                            // Recalculate deposit
                            const totalEntered = updatedRows
                              .filter(row => row.allocation !== "Deposit")
                              .reduce((sum, row) => sum + parseFloat(row.amount || 0), 0);

                            const depositRowIndex = updatedRows.findIndex(row => row.allocation === "Deposit");
                            if (depositRowIndex !== -1) {
                              const remainingDeposit = (receiptDetails?.depositAmount || 0) - totalEntered;
                              updatedRows[depositRowIndex].amount = remainingDeposit >= 0 ? remainingDeposit.toFixed(2) : "0.00";
                            }

                            setTransferRows(updatedRows);
                          }}
                          style={{ width: 80 }}
                        />
                      ),
                    },

                  ]}
                  dataSource={transferRows}
                  rowKey={(record, idx) => idx}
                />


              </div>

              <div className="d-flex justify-content-end mt-3">
                <span style={{ fontWeight: 600, color: "red" }}>
                  {calculateDifference() < 0
                    ? `Out by $${Math.abs(calculateDifference()).toFixed(2)}`
                    : ""}
                </span>
              </div>

              <div className="d-flex justify-content-end mt-3">
                <Button className="btn-light mr-2" onClick={closeViewTrasaction}>
                  Cancel
                </Button>
                <Button
                  style={{ backgroundColor: "#348fb2", color: "white" }}
                  onClick={submitTransfer}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        }
      />


      <CustomModal width={650} closable={closeDisburse} visible={openDisburseModle} onCancel={closeDisburse}
        modalData={
          <div>
            <div style={{ padding: "20px" }}>
              <h5 style={{ color: "#348fb2", fontWeight: 600 }}>
                Are you sure you want to disburse the selected folios now?
              </h5>
              <p style={{ marginBottom: "15px", fontSize: "14px", color: "#333" }}>
                New entries will be created in the withdrawals list.
              </p>
              <div style={{
                background: "#f4f6f8",
                padding: "12px 15px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                fontSize: "14px"
              }}>
                <span style={{ marginRight: "10px", color: "#3c8dbc" }}>💡</span>
                You will need to process the withdrawals to mark those funds as having left your trust account.
              </div>


            </div>


          </div>
        }
        footer={<div style={{ marginTop: "25px", display: "flex", justifyContent: "flex-end" }}>
          <button onClick={closeDisburse} style={{ marginRight: "10px" }} className="btn btn-light">
            Cancel
          </button>
          <button style={{ background: "#348fb2", color: "white" }} onClick={() => submitDisburse()} className="btn">
            OK
          </button>
        </div>} title={null}

      />
      <CustomModal title={"Reason"} width={600} closable={closeReverseReason} visible={viewReverseReason} onCancel={closeReverseReason}
        modalData={
          <div>
            <div className="details-form p-3" style={{ display: 'initial' }}>
              <TextArea colVal={12} label="Reverse Reason" name="ReverseReason" value={reverseReason} onChange={(e) => setReverseReason(e.target.value)} />
            </div>
          </div>
        }
        footer={<div style={{ marginTop: "25px", display: "flex", justifyContent: "flex-end" }}>
          <button onClick={closeReverseReason} style={{ marginRight: "10px" }} className="btn btn-light">
            Cancel
          </button>
          <button style={{ background: "#348fb2", color: "white" }} onClick={() => handleReverse(getDetails?.referenceId)} className="btn">
            Submit
          </button>
        </div>}
      />

      <CustomModal
        title={`Rent Review ${tenant?.propertyAddress}`}
        width={800}
        closable={closeRentReview}
        visible={openRentReview}
        onCancel={closeRentReview}
        modalData={
          <Tabs defaultActiveKey="1">
            <TabPane tab="Adjust" key="1">
              <div style={{ padding: "15px" }}>
                <h6 style={{ color: "#348fb2", fontWeight: 600 }}>Tenant - TEN00003</h6>
                <div style={{ border: "1px solid #eee", display: "flex", flexWrap: "wrap", marginTop: 12 }}>
                  {[
                    { label: "Weekly", value: tenant?.rent? `${formatAmount(tenant?.rent)}`: 0 },
                    { label: "Agreement end", value: tenant?.agreementEnd ? moment(tenant.agreementEnd).format("DD MMM YYYY") : "" },
                    { label: "Paid to", value: tenant?.datePaidTo ? moment(tenant.datePaidTo).format("DD MMM") : "" },
                    { label: "Part paid", value: tenant?.partPayment ? `${formatAmount(tenant?.partPayment)}`:0 },
                    { label: "Bond held", value: tenant?.bondInTrust ? `${formatAmount(tenant?.bondInTrust)}`:0 },
                    { label: "Moved out", value: tenant?.moveOut ? `${formatAmount(tenant.moveOut)}` : "" },
                  ].map((item, idx) => (
                    <div
                      key={idx}
                      style={{
                        flex: "1 1 16.6%",
                        minWidth: 100,
                        padding: "10px 12px",
                        borderRight: idx !== 5 ? "1px solid #ddd" : "none",
                        backgroundColor: "#f9fdfd",
                        textAlign: "left",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      <div style={{ fontWeight: 600, fontSize: 12, color: "#666", marginBottom: 4 }}>
                        {item.label}
                      </div>
                      <div style={{ fontSize: 14 }}>{item.value || <span style={{ color: "#ccc" }}>—</span>}</div>
                    </div>
                  ))}
                </div>


                <h6 style={{ color: "#348fb2", fontWeight: 600, marginTop: "20px" }}>Rent Adjustment</h6>
                <div className="row">
                  <div className="col-6 mb-3">
                    <label>Notice period</label>
                    <Input value={rentAdjustment.noticePeriod} onChange={(e) => handleRentChange("noticePeriod", e.target.value)} />
                  </div>
                  <div className="col-6 mb-3">
                    <label>New rent from</label>
                    <DatePicker
                      value={rentAdjustment.newRentFrom}
                      format="DD/MM/YYYY"
                      locale={locale}
                      style={{ width: "100%" }}
                      onChange={(date) => handleRentChange("newRentFrom", date)}
                      allowClear
                      onFocus={() => handleRentChange("newRentFrom", null)}
                    />
                  </div>
                  <div className="col-6 mb-3">
                    <label>New rent value</label>
                    <Input value={rentAdjustment.newRentValue} onChange={(e) => handleRentChange("newRentValue", e.target.value)} />
                    {(() => {
                      const oldRent = parseFloat(tenant?.rent || 0);
                      const newRent = parseFloat(rentAdjustment.newRentValue || 0);
                      const diff = newRent - oldRent;

                      if (!isNaN(diff) && diff !== 0) {
                        const isIncrease = diff > 0;
                        return (
                          <span style={{ fontSize: 12, color: isIncrease ? "green" : "red", marginLeft: 8 }}>
                            {isIncrease ? "Increase" : "Decrease"} of ${Math.abs(diff).toFixed(2)}
                          </span>
                        );
                      }

                      return (
                        <span style={{ fontSize: 12, color: "#999", marginLeft: 8 }}>
                          No change in rent.
                        </span>
                      );
                    })()}
                  </div>
                </div>

                <Checkbox checked>Rent is unchanged for review</Checkbox>

                <div style={{
                  marginTop: "15px",
                  padding: "15px",
                  background: "#f4f6f8",
                  borderRadius: "4px",
                  fontSize: "13px",
                  lineHeight: 1.6
                }}>
                  <b style={{ color: "#348fb2" }}>💡 Rent Adjustment</b>
                  <ul style={{ margin: "10px 0 0 18px", padding: 0 }}>
                    <li>Permanently changes the tenant's rent amount</li>
                    <li>Can only adjust unpaid periods</li>
                  </ul>
                </div>
              </div>
            </TabPane>

            <TabPane tab="Details" key="2">
              <ShowValue Label='Address' setData={tenant?.propertyAddress} />
              <ShowValue Label="Attributes" setData={`${rentReviewDetails?.propertyType || ''} ${rentReviewDetails?.bathroomCount || ''} 🛏 ${rentReviewDetails?.bedCount || ''} 🛁 ${rentReviewDetails?.garageCount || ''} 🚗`} />
              <ShowValue Label='Last review' setData={getDetails?.paidBy} />
              <ShowValue Label='Next review' setData={getDetails?.paidBy} />
              <ShowValue Label='Paid to' setData={tenant?.datePaidTo ? moment(tenant.datePaidTo).format("DD MMM YYYY") : ""} />
              <ShowValue Label='Part paid' amt={true} setData={tenant?.partPayment} />
              <ShowValue Label='Moved in' setData={tenant?.moveIn ? moment(tenant.moveIn).format("DD MMM YYYY") : ""} />
              <ShowValue Label='Deposites' amt={true} setData={tenant?.deposited} />

              <div style={{ fontWeight: 600, marginTop: 20, fontSize: 16, color: "#348fb2" }}>
                📋 Last Inspection
              </div>
              <ShowValue Label='Type' setData={rentReviewDetails?.propertyType} />
              <ShowValue Label='Date' setData={getDetails?.paidBy} />
              <ShowValue Label='Rent review' setData={tenant?.rentReviewFrequency} />


            </TabPane>

            <TabPane tab="Rent History" key="3">
              <div style={{ padding: "15px" }}>Rent history content here...</div>
            </TabPane>
          </Tabs>
        }
        footer={
          <div style={{ marginTop: "25px", display: "flex", justifyContent: "flex-end" }}>
            <button onClick={closeRentReview} style={{ marginRight: "10px" }} className="btn btn-light">
              Cancel
            </button>
            <button style={{ background: "#348fb2", color: "white" }} className="btn" onClick={SubmitRentReview}>
              Save
            </button>
          </div>
        }
      />
    </div>
  );
};

export default Folio;